import styled from "styled-components";


export const AboutWrapper = styled.section`
    background:#111221;
    @media screen and (max-width:768px){
         padding:100px 0;
    }
    @media screen and (max-width:500px){
        padding:2rem 0;
    }
`;
export const AboutContainer = styled.div`
    display:grid;
    height: auto;
    width:100%;
    max-width:1150px;
    margin-right:auto;
    margin-left:auto;
    padding:0 24px;
    justify-content:center;
    
    @media screen and (max-width:868px){
        height:auto !important;
        padding:0 10px;
    }
    @media screen and (max-width:500px){
        height:auto !important;
        padding:0 0px;
    }
`;
export const AboutTitle = styled.h2`
    text-align:center;
    color:#E8175D;
    font-weight: inherit !important;
    font-size: 2rem;
    margin-top:10rem;
    @media screen and (max-width:600px){
        margin-top:0rem;
        font-size: 1.5rem;
    }
`;
export const AboutSubtitle = styled.p`
    color:#fff;
    font-size: 1.2rem;
    text-align: center;
    margin-top:1rem;
    font-weight:inherit !important;
    @media screen and (max-width:1000px){
        margin-bottom:0.1rem !important;
        padding:1rem;
        text-align:left;
        font-size:1rem;
    }
`;
export const AboutGridText = styled.div`
    display: grid;
    gap: 3.5rem;
    grid-template-columns: repeat(3,auto);
    grid-template-rows: auto auto; 
    justify-content: center;
    margin-top: 2rem;
    @media screen and (max-width:1000px){
      grid-template-columns: repeat(1,auto) !important;
      gap: 1.5rem;
      margin-top: 0rem;
    }
`;

export const AboutGridParr = styled.p`
    color: #fff;
    text-align: center;
    font-size: 1.2rem;
    @media screen and (max-width:1000px){
        text-align:left;
        padding:1rem;
        margin-bottom:-2rem;
        font-size:1rem;
        font-weight:inherit !important;
    }
`;
export const AboutTextImage = styled.div`
    display: grid;
    gap: 3.5rem;
    grid-template-columns: repeat(2,auto);
    grid-template-rows: auto auto;
    @media screen and (max-width:980px){
        grid-template-columns: repeat(1,auto);
        gap: 0.5rem;
    } 

`;
export const AboutImage = styled.div`
    width:100%;
    height:100%;
`; 
export const Img = styled.img`
    object-fit:cover;
    max-width:400px;
    border-radius:10px !important;
    @media screen and (max-width:968px){
        margin-top:2rem !important;
        display:block;
        margin:auto;
        padding:1.5rem;
        max-width:350px;
    }
`;
export const AboutTextEnd = styled.div`
    width:100%;
    height:100%;
`;
export const AboutEndPar = styled.p`
    color:#fff;
    font-size:1.2rem;
    text-align:left;
    font-weight:inherit !important;
    @media screen and (max-width:968px){
        margin-top:1rem;
        padding:1.2rem;
        text-align:left;
       font-size:1rem;
       font-weight:inherit !important;
    }
`;
export const AboutEndParchild = styled.p`
    color:#E8175D;
    font-weight:550 !important;
    font-size:1.8rem;
    margin-top:3rem;
    @media screen and (max-width:968px){
        margin-top:1rem;
        text-align:left;
        font-size:1.3rem;
    }
`;